import { inject } from '@angular/core';
import { CanMatchFn, Router, UrlTree } from '@angular/router';
import { map, Observable } from 'rxjs';
import { LicenseService } from 'app/services/license.service';
import { LicenseInfo } from 'app/models/api/license-info';

export const canMatchForDigilogUser: CanMatchFn = (): Observable<boolean | UrlTree> => {
  const licenseService: LicenseService = inject(LicenseService);
  const redirectPath: UrlTree = inject(Router).createUrlTree(['']);

  return licenseService.getLicenseInfo().pipe(
    map((license: LicenseInfo) => license?.hasDigiLogLicense || redirectPath),
  );
};
